import { useTranslation } from "react-i18next";
import {
  IconButton,
  LinearProgress,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import LaunchIcon from "@mui/icons-material/Launch";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import HorizontalWrapper from "../../../components/Details/HorizonticalWrapper";
import DetailsLinkedIcon from "../../../components/Details/DetailsLinkedIcon";

interface IDetailsErgo {
  projects: any[];
  projectInfo: any[];
  educationalInfo: any[];
  syntelestes: any[];
  locations: any[];
}

const DetailsErgo = (props: IDetailsErgo) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { projects, projectInfo, educationalInfo, syntelestes, locations } =
    props;

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: t("Τίτλος Τεκμηρίου") as string,
      minWidth: 450,
      sortable: false,
    },
    {
      field: "type",
      headerName: t("Τύπος Τεκμηρίου") as string,
      minWidth: 400,
      sortable: false,
    },
    {
      field: "collectionTitle",
      headerName: t("Τίτλος Συλλογής") as string,
      minWidth: 450,
      sortable: false,
    },
    {
      field: "info",
      headerName: t("Λεπτομέρειες") as string,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          title={t("Προβολή")}
        >
          <IconButton
            color='primary'
            onClick={() => navigate(`${params.row.url}`)}
          >
            <LaunchIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const columns_: GridColDef[] = [
    {
      field: "name",
      headerName: t("Ονοματεπώνυμο") as string,
      minWidth: 500,
      sortable: false,
    },
    {
      field: "pseudonymo",
      headerName: t("Ψευδώνυμο") as string,
      minWidth: 420,
      sortable: false,
    },
    {
      field: "bornDate",
      headerName: t("Έτος Γέννησης") as string,
      minWidth: 220,
      sortable: false,
    },
    {
      field: "capacity",
      headerName: t("Ιδιότητα στο Έργο") as string,
      minWidth: 350,
      sortable: false,
    },
  ];

  return (
    <>
      <HorizontalWrapper title={t("Πληροφορίες Έργου")} details={projectInfo} />
      {locations?.length > 0 && (
        <DetailsLinkedIcon
          title={t("Σχετικές Τοποθεσίες")}
          detailsList={locations}
        />
      )}
      {syntelestes.length > 0 && (
        <Box mt={5} minWidth={350}>
          <Paper
            variant='outlined'
            sx={{
              height: "fit-content",
              borderRadius: 2,
              boxShadow: 0,
              backgroundColor: "transparent",
            }}
          >
            <Typography m={2} variant='h3'>
              {t("Εμπλεκόμενοι Έργου")}
            </Typography>
            <Box m={1}>
              <DataGrid
                componentsProps={{
                  pagination: {
                    SelectProps: {
                      MenuProps: {
                        disablePortal: true,
                      },
                    },
                  },
                }}
                disableColumnMenu
                disableSelectionOnClick
                hideFooter
                autoHeight
                sortingMode='server'
                columns={columns_}
                rows={syntelestes}
                components={{
                  LoadingOverlay: LinearProgress,
                  NoRowsOverlay: () => (
                    <Stack
                      height='100%'
                      alignItems='center'
                      justifyContent='center'
                    >
                      {t("Δεν υπάρχουν εγγραφές")}
                    </Stack>
                  ),
                }}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#F2F2F2",
                    fontSize: 16,
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    textOverflow: "clip",
                    whiteSpace: "break-spaces",
                    lineHeight: 1,
                  },
                  "& .MuiDataGrid-cell": {
                    textOverflow: "clip",
                    whiteSpace: "break-spaces",
                    lineHeight: 1,
                  },
                }}
              />
            </Box>
          </Paper>
        </Box>
      )}
      {educationalInfo.length > 0 && (
        <HorizontalWrapper
          title={t("Εκπαιδευτικά Στοιχεία Έργου")}
          details={educationalInfo}
        />
      )}
      {projects.length > 0 && (
        <Box mt={5} minWidth={350}>
          <Paper
            variant='outlined'
            sx={{
              height: "fit-content",
              borderRadius: 2,
              boxShadow: 0,
              backgroundColor: "transparent",
            }}
          >
            <Typography m={2} variant='h3'>
              {t("Τεκμήρια Έργου")}
            </Typography>
            <Box m={1}>
              <DataGrid
                autoHeight
                disableColumnMenu
                sortingMode='server'
                columns={columns}
                rows={projects}
                components={{
                  LoadingOverlay: LinearProgress,
                  NoRowsOverlay: () => (
                    <Stack
                      height='100%'
                      alignItems='center'
                      justifyContent='center'
                    >
                      {t("Δεν υπάρχουν εγγραφές")}
                    </Stack>
                  ),
                }}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#F2F2F2",
                    fontSize: 16,
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    textOverflow: "clip",
                    whiteSpace: "break-spaces",
                    lineHeight: 1,
                  },
                  "& .MuiDataGrid-cell": {
                    textOverflow: "clip",
                    whiteSpace: "break-spaces",
                    lineHeight: 1,
                  },
                }}
              />
            </Box>
          </Paper>
        </Box>
      )}
    </>
  );
};

export default DetailsErgo;
